import { v4 as uuidv4 } from 'uuid';

import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RatingSummary } from '../../../../vtex-apps/peer/reviews-and-ratings/RatingSummary/default';
import { Wishlist } from '../../../../vtex-apps/peer/wishlist/Wishlist/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { ProductImages } from '../../../../vtex-apps/store-components/ProductImages/default';
import { ProductIdentifier } from '../../../../vtex-apps/product-identifier/ProductIdentifier/default';
import { ProductName } from '../../../../vtex-apps/store-components/ProductName/default';
import { ProductHighlights } from '../../../../vtex-apps/product-highlights/ProductHighlights/default';
import { Share } from '../../../../vtex-apps/store-components/Share/default';
import { ModalHeader } from '../../../../vtex-apps/modal-layout/ModalHeader/default';
import { ModalLayout } from '../../../../vtex-apps/modal-layout/ModalLayout/default';
import { ModalTrigger } from '../../../../vtex-apps/modal-layout/ModalTrigger/default';
import { FormInputText } from '../../../../vtex-apps/store-form/FormInputTextDefault';
import { FormInputRadiogroup } from '../../../../vtex-apps/store-form/FormInputRadioGroupDefault';
import { FormSubmit } from '../../../../vtex-apps/store-form/FormSubmitDefault';
import { Link } from '../../../../vtex-apps/Link/Link/default';
import { FormSuccess } from '../../../../vtex-apps/store-form/FormSuccessDefault';
import { Form } from '../../../../vtex-apps/store-form/FormDefault';

export default function ProductImagesDetailsGroup() {
	return {
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
		componentGroup: 'ProductImagesDetailsGroup',
		props: FlexLayoutRow({
			blockClass: 'product-wrapper__pidg-3',
			marginTop: 9,
			marginBottom: 9,
			preserveLayoutOnMobile: false,
			mzTitle: 'MZ | Bloco principal',
		}).props,
		variables,
		childrenComponents: [
			FlexLayoutCol(
				{
					width: { desktop: '60%', tablet: '100%', phone: '100%' },
					blockClass: 'product-image-dg-left__flex-col-pidg-3',
					preventVerticalStretch: true,
				},
				[
					Wishlist({ blockClass: 'product-wishlist__pidg-3' }),
					ProductImages({
						blockClass: 'product-images__pidg-3',
						showPaginationDots: 'always',
						maxHeight: 600,
					}),
				],
			),
			FlexLayoutCol(
				{
					width: { desktop: '40%', tablet: '100%', phone: '100%' },
					blockClass: 'product-image-dg-right__flex-col-pidg-3',
				},
				[
					ProductIdentifier(),
					FlexLayoutRow(
						{
							blockClass: 'product-highlights-wrapper__pidg-3',
							preventHorizontalStretch: true,
						},
						[ProductHighlights({ blockClass: 'product-highlights__pidg-3' })],
					),
					FlexLayoutRow({}, [ProductName({ blockClass: 'product-name__pidg-3' })]),
					RatingSummary({
						blockClass: 'product-reviewsSummary__pidg-3',
					}),
					FlexLayoutRow(
						{
							marginTop: { desktop: 7, tablet: 7, phone: 7 },
							marginBottom: { desktop: 8, tablet: 8, phone: 8 },
							colSizing: 'equal',
						},
						[
							ModalTrigger({}, [
								Link({
									displayMode: 'button',
									label: 'Solicitar Orçamento',
									blockClass: 'budget-button__pidg-3',
								}),
								ModalLayout({ blockClass: 'modal-budget__pidg-3' }, [
									FlexLayoutRow(
										{
											paddingBottom: {
												desktop: 6,
												tablet: 6,
												phone: 6,
											},
											colSizing: 'equal',
										},
										[
											ModalHeader({ blockClass: 'modal-header__pidg-3', iconCloseSize: 20 }, [
												RichText({
													blockClass: 'modal-header__pidg-3',
													text: 'Solicitar Orçamento',
												}),
											]),
										],
									),
									FlexLayoutRow({ blockClass: 'form-wrapper__pidg-3', colSizing: 'equal' }, [
										Form(
											{ entity: 'orcamento', schema: 'mz-orcamento' },
											[
												FormInputRadiogroup({ blockClass: 'modal-form__pidg-3' }),
												FormInputText({
													label: 'Nome',
												}),
												FormInputText({
													label: 'CPF/CNPJ',
												}),
												FormInputText({
													label: 'Contato',
												}),
												FormInputText({
													label: 'E-mail',
													placeholder: 'email@gmail.com',
												}),
												FormInputText({
													label: 'Telefone',
													placeholder: '(11) 99999-9999',
												}),
												FormInputText({
													label: 'Observações',
												}),
												FormSubmit({
													label: 'Enviar Orçamento',
												}),
											],
											[
												FormSuccess({}, [
													RichText({
														blockClass: 'rich-text-success__pidg-3',
														text: 'Recebemos sua solicitação!',
													}),
												]),
											],
										),
									]),
								]),
							]),
						],
					),
					Share({
						blockClass: 'share__pidg-3',
						shareLabelClass: 'share-label__pidg-3',
						buttonsContainerClass: 'share-btn-container__pidg-3',
					}),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--text-color-1', to: '--pidg-3-text-color', name: 'General Text' },
			{ from: '--text-color-1', to: '--pidg-3-reviews-color', name: 'Reviews' },
			{ from: '--cta-color-pure', to: '--pidg-3-cta-color', name: 'CTA' },
			{ from: '--cta-color-hover', to: '--pidg-3-cta-hover', name: 'CTA Hover' },
			{ from: '--cta-color-focus', to: '--pidg-3-cta-focus', name: 'CTA Active' },
			{ from: '--white', to: '--pidg-3-cta-text-color', name: 'CTA Text Color' },
			{ from: '--cta-color-pure', to: '--pidg-3-flag-color', name: 'Highlight Background' },
			{ from: '--white', to: '--pidg-3-highlight-text-color', name: 'Highlight Text' },
			{ from: '--cta-color-pure', to: '--pidg-3-slider-color', name: 'Slider' },
			{ from: '--text-color-1', to: '--pidg-3-modal-h-color', name: 'Modal Header' },
			{ from: '--text-color-1', to: '--pidg-3-modal-l-color', name: 'Modal Label' },
			{ from: '--text-color-1', to: '--pidg-3-modal-i-color', name: 'Modal Input' },
			{ from: '--text-color-1', to: '--pidg-3-modal-i-p-color', name: 'Modal Placeholder' },
			{ from: '--text-color-1', to: '--pidg-3-rt-success-text-color', name: 'Success Text' },
			{ from: '--brand-color-primary-pure', to: '--pidg-3-wishlist', name: 'wishlist' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--pidg-3-br', name: 'Details' },
			{ from: '--border-radius-none', to: '--pidg-3-image-br', name: 'Image' },
			{ from: '--border-radius-none', to: '--pidg-3-cta-br', name: 'CTA' },
			{ from: '--border-radius-none', to: '--pidg-3-slider-br', name: 'Slider' },
			{ from: '--border-radius-sm', to: '--pidg-3-modal-container-br', name: 'Modal Container' },
			{ from: '--border-radius-none', to: '--pidg-3-modal-br', name: 'Modal Input' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-nano', to: '--pidg-3-highlight-size', name: 'Highlight' },
			{ from: '--spacing-sm', to: '--pidg-3-cta-size', name: 'CTA' },
			{ from: '--spacing-sm', to: '--pidg-3-dot-width', name: 'Dot Width' },
			{ from: '--spacing-nano', to: '--pidg-3-dot-height', name: 'Dot height' },
			{ from: '--spacing-sm', to: '--pidg-3-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--pidg-3-dot-height-active', name: 'Dot Height Active' },
			{ from: '--spacing-md', to: '--pidg-3-modal-size', name: 'Modal Input Size' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--pidg-3-text-fs', name: 'General Text' },
			{ from: '--font-size-lg', to: '--pidg-3-product-name-fs', name: 'Product Name' },
			{ from: '--font-size-xs', to: '--pidg-3-highlight-fs', name: 'Highlight' },
			{ from: '--font-size-md', to: '--pidg-3-cta-fs', name: 'CTA' },
			{ from: '--font-size-xs', to: '--pidg-3-modal-l-fs', name: 'Modal Label' },
			{ from: '--font-size-xs', to: '--pidg-3-modal-i-fs', name: 'Modal Input' },
			{ from: '--font-size-xs', to: '--pidg-3-rt-success-fs', name: 'Success Text' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--pidg-3-text-fw', name: 'General Text' },
			{ from: '--font-weight-700', to: '--pidg-3-product-name-fw', name: 'Product Name' },
			{ from: '--font-weight-400', to: '--pidg-3-highlight-fw', name: 'Highlight' },
			{ from: '--font-weight-700', to: '--pidg-3-cta-fw', name: 'CTA' },
			{ from: '--font-weight-400', to: '--pidg-3-modal-l-fw', name: 'Modal Label' },
			{ from: '--font-weight-400', to: '--pidg-3-modal-i-fw', name: 'Modal Input' },
			{ from: '--font-weight-400', to: '--pidg-3-rt-success-fw', name: 'Success Text' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--pidg-3-text-ff', name: 'General Text' },
			{ from: '--main-font', to: '--pidg-3-product-name-ff', name: 'Product Name' },
			{ from: '--main-font', to: '--pidg-3-highlight-ff', name: 'Highlight' },
			{ from: '--main-font', to: '--pidg-3-cta-ff', name: 'CTA' },
			{ from: '--main-font', to: '--pidg-3-modal-h-ff', name: 'Modal Header' },
			{ from: '--main-font', to: '--pidg-3-modal-l-ff', name: 'Modal Label' },
			{ from: '--main-font', to: '--pidg-3-modal-i-ff', name: 'Modal Input' },
			{ from: '--main-font', to: '--pidg-3-rt-success-ff', name: 'Success Text' },
		],
	},
];
